import { adminRequests } from 'api/request';
import urls from 'configs/urls';

export const addCompany = ({ data }) =>
  adminRequests.post(null, false, urls.companiesUrls.addCompany, data);
